<div class="text-left text-lg font-medium">
  <fa-icon class="mr-1.5" [icon]="icon"></fa-icon>
    <a [routerLink]="link" *ngIf="!raw">{{title}}</a>
    <a [href]="link" *ngIf="raw">{{title}}</a>
</div>
